import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AlertsModule } from './alerts/alerts.module';
import { AssignedRwicsComponent } from './assigned-rwics/assigned-rwics.component';
import { AutofocusDirective } from './directives/autofocus.directive';
import { CommonModule } from '@angular/common';
import { CurrencyInputModule } from './currency-input/currency-input.module';
import { DwrTableComponent } from './dwr-table/dwr-table.component';
import { ErrorDialogComponent } from './utilities/error-dialog/error-dialog.component';
import { FieldContactComponent } from './field-contact/field-contact.component';
import { FilterFnPipe } from './pipes/filter-fn.pipe';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormFieldComponent } from './form-field/form-field.component';
import { FullNamePipe } from './pipes/full-name.pipe';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LeftArrowComponent } from './canvas-shapes/left-arrow/left-arrow.component';
import { LineItemTableComponent } from './line-item-table/line-item-table.component';
import { MaterialModule } from 'src/shared/material/material.module';
import { NgModule } from '@angular/core';
import { NormalizeDirective } from './directives/normalize-fields.directive';
import { OtherChargeComponent } from './other-charge/other-charge.component';
import { PaycheckTableComponent } from './paycheck-table/paycheck-table.component';
import { PhonePipe } from './pipes/phone.pipe';
import { RailroadLogoComponent } from './railroad-logo/railroad-logo.component';
import { RailroadSubCodeComponent } from './railroad-sub-code/railroad-sub-code.component';
import { RailroadSubCodeDialogComponent } from './railroad-sub-code/railroad-sub-code-dialog/railroad-sub-code-dialog.component';
import { RemoveHostDirective } from './directives/remove-host.directive';
import { RightArrowComponent } from './canvas-shapes/right-arrow/right-arrow.component';
import { RouterModule } from '@angular/router';
import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
	imports: [
		CommonModule,
		MaterialModule,
		FormsModule,
		FlexLayoutModule,
		ReactiveFormsModule,
		RouterModule,
		LeafletModule,
		TextMaskModule,
		AlertsModule,
		CurrencyInputModule,
	],
	declarations: [
		FilterFnPipe,
		PhonePipe,
		FullNamePipe,
		FieldContactComponent,
		AssignedRwicsComponent,
		DwrTableComponent,
		PaycheckTableComponent,
		LineItemTableComponent,
		LeftArrowComponent,
		RightArrowComponent,
		FormFieldComponent,
		ErrorDialogComponent,
		RemoveHostDirective,
		NormalizeDirective,
		OtherChargeComponent,
		AutofocusDirective,
		RailroadSubCodeComponent,
		RailroadSubCodeDialogComponent,
		RailroadLogoComponent,
	],
	exports: [
		FilterFnPipe,
		PhonePipe,
		FullNamePipe,
		FieldContactComponent,
		AssignedRwicsComponent,
		DwrTableComponent,
		PaycheckTableComponent,
		LineItemTableComponent,
		LeftArrowComponent,
		RightArrowComponent,
		FormFieldComponent,
		RemoveHostDirective,
		NormalizeDirective,
		OtherChargeComponent,
		RailroadLogoComponent,
	],
})
export class SharedGlobalModule {}
